/**
 * Standard pagination configuration for the entire application
 * Default page size: 100 rows
 * Available page size options: [5, 10, 15, 20, 50, 100]
 */

export const PAGINATION_CONFIG = {
  DEFAULT_PAGE_SIZE: 100,
  PAGE_SIZE_OPTIONS: [5, 10, 15, 20, 50, 100] as const,
} as const;

/** Mutable copy of PAGE_SIZE_OPTIONS for DataGrid */
export const getPageSizeOptionsForDataGrid = (): number[] =>
  [...PAGINATION_CONFIG.PAGE_SIZE_OPTIONS];

/**
 * Get DataGrid pagination props for MUI DataGrid component
 * @returns Object containing initialState and pageSizeOptions
 */
export const getDataGridPaginationProps = () => ({
  initialState: {
    pagination: {
      paginationModel: {
        pageSize: PAGINATION_CONFIG.DEFAULT_PAGE_SIZE,
      },
    },
  },
  pageSizeOptions: getPageSizeOptionsForDataGrid(),
});

/**
 * Get TablePagination props for MUI TablePagination component
 * @returns Object containing rowsPerPageOptions
 */
export const getTablePaginationProps = () => ({
  rowsPerPageOptions: PAGINATION_CONFIG.PAGE_SIZE_OPTIONS,
});
